import { createApp } from 'vue';
import { configureApp } from '@/configure-app';

/**
 *  Want to learn more about Mirage (Mock Server)
 *  @see Docs (@link https://miragejs.com/)
 *  @see Tutorial (@link https://css-tricks.com/dont-wait-mock-the-api/)
 */

import App from './App.vue';
import { defineCustomElement } from './defineCustomElement';
import { WbCpp } from './custom-element';

const app = createApp(App);
configureApp(app);
app.mount('#app');

if (process.env.NODE_ENV === 'webcomponent') {
  defineCustomElement();
}

export { WbCpp, defineCustomElement };
